import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=0aca9549&scoped=true"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=0aca9549&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca9549",
  null
  
)

export default component.exports